<mat-table
  [dataSource]="items"
  matSort
  matSortDisableClear
  [matSortActive]="sort"
  [matSortDirection]="sortDirection"
  (matSortChange)="onSortChange($event)"
>
  <ng-container matColumnDef="caseNumber">
    <mat-header-cell *matHeaderCellDef mat-sort-header="caseNumber">{{ 'common.caseNumber' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">
        {{ item.caseNumber }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="firstName">
    <mat-header-cell *matHeaderCellDef mat-sort-header="firstName">{{ 'common.creator' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate"> {{ item.user.firstName }} {{ item.user.lastName }} </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="createdTimestamp">
    <mat-header-cell *matHeaderCellDef mat-sort-header="createdTimestamp">{{ 'common.date' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      {{ item.createdTimestamp | fsFormatDate }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef>{{ 'common.actions' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-action-list [items]="actions" [context]="item" alwaysExpand></sn-action-list>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row
    matRipple
    [@snFadeIn]
    [@snFadeOut]
    (click)="onItemTap(item)"
    (doubletap)="onItemDblTap(item)"
    *matRowDef="let item; columns: columns"
  >
  </mat-row>
</mat-table>
